module.exports = __webpack_public_path__ + "media/honey-icons/icon-play-circle-7d2640a5.svg";